import { render, staticRenderFns } from "./HomeProjectCard.vue?vue&type=template&id=581e50a6"
import script from "./HomeProjectCard.vue?vue&type=script&lang=js"
export * from "./HomeProjectCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports